export default __webpack_public_path__ + "static/icon-banner-d4738910b3424f9cf79efd955bc285d9.png";